import styled from '@emotion/styled';
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react';

import { Button } from '../Button/Button';
import { CloseButton } from '../Button/components/CloseButton';
import { Form } from '../Form/Form';

export const StyledDialog = styled(Dialog)`
  position: relative;
  z-index: 10000;
`;

export const Backdrop = styled.div`
  position: fixed;
  background-color: rgba(0, 0, 0, 0.5);
  inset: 0;
  display: flex;
  width: 100vw;
  align-items: center;
  justify-content: center;
`;

export const StyledDialogPanel = styled(DialogPanel)`
  width: 100%;
  max-width: 600px;
  height: 100%;
  background-color: var(--color-white);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);

  @media (min-width: 600px) {
    width: 600px;
    height: auto;
    border-radius: var(--border-radius-m);
  }
`;

export const StyledDialogTitle = styled(DialogTitle)`
  font: var(--font-heading-5);
  color: var(--color-black);
  margin-right: var(--spacing-16);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: var(--spacing-16);
`;

export const StyledForm = styled(Form)`
  height: 100%;
  gap: var(--spacing-32);
  justify-content: space-between;

  @media (min-width: 600px) {
    height: calc(100% - 48px);
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  padding: var(--spacing-24) var(--spacing-16);

  @media (min-width: 600px) {
    padding: var(--spacing-24);
  }
`;

export const StyledCloseButton = styled(CloseButton)`
  margin-left: auto;
`;

export const Body = styled.div`
  flex: 1;

  @media (min-width: 600px) {
    margin-top: var(--spacing-12);
  }
`;

export const FieldsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  padding: 0 var(--spacing-16);
  box-sizing: border-box;
  overflow-y: auto;
  flex: 1 0 0;

  @media (min-width: 600px) {
    overflow-y: visible;
    width: 460px;
    margin-inline: auto;
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  border-top: solid 1px var(--color-neutral-30);
  padding: var(--spacing-24);
  margin-top: auto;
`;

export const StyledButton = styled(Button)`
  min-width: 300px;
  margin-inline: auto;
`;

export const FakeLink = styled.button`
  background: none;
  text-decoration: underline;
  cursor: pointer;
  border: none;
`;
